module.exports = __webpack_public_path__ + "img/research_sessions.4296cb58.png";